import script from "./chanping-4.vue?vue&type=script&setup=true&lang=js"
export * from "./chanping-4.vue?vue&type=script&setup=true&lang=js"

import "./chanping-4.vue?vue&type=style&index=0&id=68152ff2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68152ff2"]])

export default __exports__